// import Alpine from "alpinejs";
import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { searchBox, hits, pagination, configure, stats } from "instantsearch.js/es/widgets";
import { connectRefinementList } from "instantsearch.js/es/connectors";

/* eslint-disable no-console */

// Alpine.data("algoliaSearch", config => {
let algoliaSearch = config => {
    return {
        config: {
            /**
             * Props are coming from light-modules/sanofi-lm-platform/templates/areas/sanofi-platform/search/searchAlgolia.ftl
             */
            algoliaAppId: "",
            algoliaAnonymousKey: "",
            algoliaAuthenticatedKey: "",
            algoliaIndexName: "",
            cssClassForm: "",
            cssClassInput: "",
            cssClassIcon: "",
            cssClassResultTitle: "",
            cssClassResultLink: "",
            cssClassResultDescription: "",
            cssClassPaginationTextColor: "",
            cssClassPaginationHoverTextColor: "",
            noResultsMessage: "",
            showCategories: false,
            refinementListCountBackground: "",
            refinementListCountText: "",
            refinemenListFilterBy: "",
            summaryDisplay: "",
            isAnonymous: "",
            isRolesEnabled: "",
            userPluralValue: "",
            ...config
        },

        widgetContainerSearchBox: ".as-searchbox",
        widgetContainerHits: ".as-hits",
        widgetContainerPagination: ".as-pagination",

        renderResultsOnLoad: false,
        isShowingResults: false,
        hasResults: false,
        instantsearch: null,

        hasCategories() {
            return !!this.showCategories;
        },

        isAnonymous() {
            if (this.config.isAnonymous === "true") return true;
        },
        init() {
            const indication = document.querySelector("[data-indication]");
            const self = this;
            let algoliaClient = algoliasearch(this.config.algoliaAppId, this.config.algoliaAuthenticatedKey);
            // Set no results message from DOM template
            this.config.noResultsMessage = self.$refs.noResults.innerHTML.toString();

            if (this.isAnonymous()) {
                algoliaClient = algoliasearch(this.config.algoliaAppId, this.config.algoliaAnonymousKey);
            }

            const searchClient = {
                ...algoliaClient,
                search(requests) {
                    if (!self.renderResultsOnLoad) {
                        /**
                         * Do not render results on pageload
                         * https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/js/#detecting-empty-search-requests
                         */
                        if (requests.every(({ params }) => !params.query)) {
                            self.isShowingResults = false;
                            return Promise.resolve({
                                results: requests.map(() => ({
                                    hits: [],
                                    nbHits: 0,
                                    nbPages: 0,
                                    page: 0,
                                    processingTimeMS: 0
                                }))
                            });
                        }
                    }

                    self.isShowingResults = true;
                    return algoliaClient.search(requests);
                }
            };

            const algoliaIndexName = this.config.algoliaIndexName;

            let instantsearchProps = {
                indexName: algoliaIndexName,
                searchClient: searchClient
            };

            let urlParams = new URLSearchParams(window.location.search);
            let queryString = urlParams.get("q");
            if (queryString) {
                instantsearchProps.routing = {
                    stateMapping: {
                        stateToRoute(uiState) {
                            const indexUiState = uiState[algoliaIndexName] || {};
                            return {
                                q: indexUiState.query
                            };
                        },
                        routeToState(routeState) {
                            return {
                                [algoliaIndexName]: {
                                    query: routeState.q
                                }
                            };
                        }
                    }
                };
            }

            this.instantsearch = instantsearch(instantsearchProps);

            // filters
            let filterFranchise = `indications:"franchise"`;
            let filterIndication = `indications:"${indication.dataset.indication}"`;
            let filterEvents = `pageType:"events"`;
            let filterQuery = indication.dataset.indication == "franchise" ? `(${filterFranchise} OR ${filterEvents})` : `(${filterFranchise} OR ${filterIndication})`;

            const widgetList = [
                configure({
                    attributesToSnippet: ["content:50", "description:50"],
                    filters: filterQuery
                }),
                /**
                 * Searchbox
                 * https://www.algolia.com/doc/api-reference/widgets/search-box/js/
                 */
                searchBox({
                    container: this.widgetContainerSearchBox,
                    showReset: true,
                    showLoadingIndicator: false,
                    cssClasses: {
                        form: self.config?.cssClassForm,
                        input: self.config?.cssClassInput,
                        submit: self.config?.cssClassIcon,
                        reset: self.config?.cssClassIcon
                    },
                    queryHook: (query, search) => {
                        // Clear categories refinement on a new search
                        if (this.hasCategories()) {
                            this.instantsearch.helper.clearRefinements("categories");
                            this.instantsearch.helper.clearRefinements("displayFileTypes");
                        }
                        search(query);
                    }
                }),

                /*
                 * Hits
                 * https://www.algolia.com/doc/api-reference/widgets/hits/js/
                 */
                hits({
                    container: this.widgetContainerHits,
                    escapeHTML: true,
                    templates: {
                        item(hit, { html, components }) {
                            let summary =
                                self.config?.summaryDisplay !== "none"
                                    ? html`
                                          <p class="hits-summary ${self.config?.cssClassResultDescription}">${components.Snippet({ attribute: self.config?.summaryDisplay, hit, highlightedTagName: "mark" })}</p>
                                      `
                                    : "";

                            return html`
                                <a href="${hit.url}" class="block">
                                    <h3 class="${self.config?.cssClassResultTitle}">${components.Highlight({ attribute: "title", hit })}</h3>
                                    ${summary}
                                    ${self.config?.usabilityFlag === "true"
                                        ? ""
                                        : html`
                                              <p class="hits-url ${self.config?.cssClassResultLink}">${hit.url}</p>
                                          `}
                                </a>
                            `;
                        },
                        empty(results, { html }) {
                            return html`
                                ${self.config.noResultsMessage.replaceAll("${query}", results.query)}
                            `;
                        }
                    }

                    /**
                     * This is helpful to review the schema of results from Algolia
                     */
                    // transformItems(items) {
                    //     console.log(items);
                    //     return items;
                    // },
                }),

                /**
                 * Pagination
                 * https://www.algolia.com/doc/api-reference/widgets/pagination/js/
                 */
                pagination({
                    container: this.widgetContainerPagination,
                    cssClasses: {
                        link: ` ${self.config?.cssClassPaginationTextColor} ${self.config?.cssClassPaginationHoverTextColor}`
                    }
                })
            ];
            /**
             * Refinement List
             * https://www.algolia.com/doc/api-reference/widgets/refinement-list/js/
             */
            const renderRefinementList = renderOptions => {
                const { items, refine, widgetParams } = renderOptions;
                const container = document.querySelector(widgetParams.container);
                container.innerHTML = `
                <ul>
                  ${items
                      .map(
                          item => `
                          <li class="ais-RefinementList-item">
                            <div>
                                <label class="ais-RefinementList-label">
                                    <input :class="${item.isRefined} ? 'isChecked' : ''" ${item.isRefined ? "checked" : ""}  type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}">
                                    <span class="ais-RefinementList-labelText">${item.value}</span>
                                </label>
                            </div>
                          </li>
                          `
                      )
                      .join("")}
                </ul>
              `;
                [...container.querySelectorAll("input")].forEach(element => {
                    ["click", "keyup"].forEach(evt => {
                        element.addEventListener(evt, event => {
                            if (evt === "keyup" && event.key === "Enter") {
                                event.preventDefault();
                                const time = 250; // Time needs to be >= 250ms
                                // This gives you the name of the old item.
                                let name = event.currentTarget.value;
                                refine(event.currentTarget.value);
                                setTimeout(() => {
                                    // Get all of the new items.
                                    let items = document.querySelectorAll(".ais-RefinementList-item");
                                    for (let item of items) {
                                        let itemInput = item.querySelector("input");
                                        if (itemInput.value == name) {
                                            // Focus on the new item.
                                            itemInput.focus();
                                        }
                                    }
                                }, time);
                            } else if (evt === "click") {
                                event.preventDefault();
                                refine(event.currentTarget.value);
                            }
                        });
                    });
                });
            };
            const customRefinementList = connectRefinementList(renderRefinementList);
            widgetList.push(
                customRefinementList({
                    container: "#refinementListTopics",
                    attribute: "categories",
                    operator: `${self.config?.refinementListFilterBy}`
                }),
                customRefinementList({
                    container: "#refinementListFileType",
                    attribute: "displayFileTypes",
                    operator: `${self.config?.refinementListFilterBy}`
                })
            );

            /**
             * Stats
             * https://www.algolia.com/doc/api-reference/widgets/stats/js/
             */

            widgetList.push(
                stats({
                    container: ".statsContainer",
                    templates: {
                        text(data, { html }) {
                            let count = "";
                            if (data.hasManyResults) {
                                count += `${data.nbHits} Results`;
                            } else if (data.hasOneResult) {
                                count += `1 Result`;
                            } else {
                                count += `0 Results`;
                            }

                            if (data.nbPages === 1) {
                                self.$refs.pagination.classList.add("hidden");
                            } else {
                                self.$refs.pagination.classList.remove("hidden");
                            }

                            return html`
                                <h3>Search Results<span class="stats-bar">|</span><span class="stats-count">${count}</span></h3>
                            `;
                        }
                    }
                })
            );

            this.instantsearch.addWidgets(widgetList);

            this.instantsearch.start();
            this.instantsearch.on("render", () => {
                const noOfResults = this.instantsearch.helper.lastResults?.nbHits || 0;
                this.hasResults = noOfResults > 0;
            });
        }
    };
};

window.algoliaSearch = algoliaSearch;
